import { useState } from "react";
import Input from "../components/Input";
import { T } from "../constants/theme";
import Btn from "../components/Btn";
import Badge from "../components/Badge";
import StepBar from "../components/StepBar";
import logo from "../logo.png";
import bgImage from "../login-bg.png";
import logo1 from "../logo1.png";
import { API_BASE_URL } from "../config";

export default function LoginScreen({
  onLogin,
  onRegister,
  onForgotPassword,
  justRegisteredId,
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      setError("Please enter your Student ID and password.");
      return;
    }

    try {
      setError("");
      setLoading(true);

      const response = await fetch(
        `${API_BASE_URL}/api/auth/student-login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            studentId: username,
            password: password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message ||
          data.error ||
          "Invalid Student ID or Password"
        );
      }

      // Save token & user details in session storage
      sessionStorage.setItem("token", data.token);
      sessionStorage.setItem("studentId", data.studentId);
      sessionStorage.setItem("studentName", data.studentName);
      sessionStorage.setItem("mobile", data.mobile);
      sessionStorage.setItem("role", data.role);

      sessionStorage.setItem("registrationStatus", data.registrationStatus);

      sessionStorage.setItem("paymentCompleted", data.paymentCompleted);
      sessionStorage.setItem("registrationId", data.registrationId);

      if (onLogin) {
        onLogin(data);
      }
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",

        background: `

  linear-gradient(

    rgba(0, 0, 0, 0.6),

    rgba(0, 0, 0, 0.6)

  ),

  url(${bgImage})

`,

        backgroundSize: "cover, cover",

        backgroundPosition: "center, center",

        backgroundRepeat: "no-repeat, no-repeat",

        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        padding: 20,
      }}
    >
      <div style={{ width: "100%", maxWidth: 400 }}>
        {/* Logo */}

        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img
            src={logo1}
            alt="Shabbas Academy Logo"
            style={{
              width: 100,

              height: 100,

              objectFit: "contain",

              marginBottom: 10,
            }}
          />

          <img
            src={logo}
            alt="Shabbas Academy"
            style={{
              width: 200,

              height: "auto",

              objectFit: "contain",

              marginBottom: 5,

              display: "block",

              marginLeft: "auto",

              marginRight: "auto",
            }}
          />

          <div
            style={{
              fontSize: 12,

              color: "rgba(255,255,255,0.5)",

              marginTop: 3,

              letterSpacing: "0.05em",

              textTransform: "uppercase",
            }}
          >
            Student Portal · Maharashtra
          </div>
        </div>

        {/* Card */}

        <div
          style={{
            background: T.white,

            borderRadius: 16,

            padding: "28px 28px 24px",

            boxShadow: "0 24px 60px rgba(0,0,0,0.35)",
          }}
        >
          <h2
            style={{
              fontSize: 18,

              fontWeight: 800,

              color: T.indigo,

              marginBottom: 4,
            }}
          >
            Welcome Back
          </h2>

          <p style={{ fontSize: 13, color: T.gray600, marginBottom: 22 }}>
            Sign in to access your dashboard
          </p>

          {justRegisteredId && (
            <div
              style={{
                background: T.greenLight,

                border: `1px solid ${T.green}30`,

                borderRadius: 8,

                padding: "10px 12px",

                fontSize: 12,

                color: T.green,

                marginBottom: 16,

                fontWeight: 600,
              }}
            >
              ✅ Registration complete! Use Student ID{" "}
              <strong>{justRegisteredId}</strong> to log in.
            </div>
          )}

          <Input
            label="Student ID"
            value={username}
            onChange={setUsername}
            placeholder="e.g. STS000001"
            hint="Your auto-generated Student ID is your username"
          />

          <Input
            label="Password"
            type="password"
            value={password}
            onChange={setPassword}
            placeholder="Enter your password"
          />

          {error && (
            <div
              style={{
                background: T.redLight,

                border: `1px solid ${T.red}30`,

                borderRadius: 8,

                padding: "10px 12px",

                fontSize: 13,

                color: T.red,

                marginBottom: 16,
              }}
            >
              ⚠ {error}
            </div>
          )}

          <Btn onClick={handleLogin} disabled={loading} full>
            {loading ? "Signing in…" : "LOGIN"}
          </Btn>

          <div style={{ textAlign: "right", marginTop: 10 }}>
            <span
              onClick={onForgotPassword}
              style={{
                fontSize: 12,
                color: T.saffron,
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Forgot Password?
            </span>
          </div>

          <div
            style={{
              borderTop: `1px solid ${T.gray100}`,

              marginTop: 20,

              paddingTop: 18,

              textAlign: "center",
            }}
          >
            <p style={{ fontSize: 13, color: T.gray600, marginBottom: 10 }}>
              New student? Register for the exam
            </p>

            <Btn onClick={onRegister} variant="outline" full>
              Register Now
            </Btn>
          </div>
        </div>

        <p
          style={{
            textAlign: "center",

            fontSize: 11,

            color: "rgba(255,255,255,0.35)",

            marginTop: 16,
          }}
        >
          Shabbas Academy · State-Level Examination Platform · Maharashtra
        </p>
      </div>
    </div>
  );
}